module.exports = __webpack_public_path__ + "static/img/home-black-bg.d259080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-black-bg.jpg
// module id = bcdD
// module chunks = 1